module.exports = "<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" x=\"0px\" y=\"0px\" width=\"24px\" height=\"24px\" viewBox=\"0 0 24 24\" enable-background=\"new 0 0 24 24\" xml:space=\"preserve\" stroke=\"currentColor\" fill=\"none\">\r\n<polyline stroke-width=\"2\" stroke-miterlimit=\"10\" points=\"20.815,12 11.622,20.192 2.43,12\"/>\r\n<polyline stroke-width=\"2\" stroke-miterlimit=\"10\" points=\"20.815,5 11.622,13.192 2.43,5\"/>\r\n</svg>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/icons/WRR.svg
// module id = 112
// module chunks = 0 1